
















































































































































































































































































































































































































/* eslint-disable camelcase, no-bitwise */
import { Component, Vue, Watch } from 'vue-property-decorator';
import breadcrumb from './fcBreadcrumb.json';

interface breadcrumb {
  href: string;
  label: string;
}
interface Node {
  p3_bne_name?: string;
  p4_node_name?: string;
  p4_node_route?: string;
  crud: number;
  p4_node_id: number;
  p4_node_pid: number;
}

const getToolbarCrud = (feature: toolbar): number => {
  switch (feature) {
    case 'create':
      return 8;
    case 'save':
    case 'saveAndGo':
    case 'keepCreate':
    case 'modify':
    case 'allPass':
    case 'allFail':
    case 'allOpen':
    case 'allClose':
      return 2;
    case 'delete':
      return 1;
    case 'info':
    case 'role':
    case 'search':
    case 'advSearch':
    case 'pager':
    case 'export':
    case 'yesterday':
    case 'today':
    case 'BeforeWeek':
    case 'Week':
    case 'BeforeMoon':
    case 'Moon':
    case 'customTime':
      return 4;
    default:
      return 0;
  }
};

const getRouterPermission = (
  toolbars: toolbar[],
  feature: toolbar,
): boolean => {
  if (Array.isArray(toolbars)) {
    return toolbars.indexOf(feature) !== -1;
  }
  return false;
};

@Component
export default class Toolbar extends Vue {
  private collapse: boolean = false;

  private styleObj: any = {
    left: `${this.getSidebarWidth}px`,
    width: `calc(100% - ${this.$store.state.getSidebar.width}px)`,
  };

  private init_styleObj: any = {
    width: `calc(100% - ${this.$store.state.getSidebar.initwidth}px)`,
  };

  private keyword: string = ''; // 搜尋用關鍵字

  private breadcrumb: Array<object> = [];

  private toolbar: boolean = false;

  private paginator: number = 1;

  private init_sidebar_width = 200;

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(newVal: any, oldVal: any) {
    this.paginator = newVal.query.page ? newVal.query.page : 1;
    this.breadcrumb = this.breadcrumbList();
    // 不在當前權限路徑下清空模糊搜尋
    if (oldVal && newVal.meta.url !== oldVal.meta.url) {
      this.keyword = '';
    }
  }

  @Watch('breadcrumbData')
  onChildChanged(val: object) {
    this.breadcrumb.push(val);
  }

  @Watch('getSidebarWidth')
  onChanged(val: number) {
    if (val !== 0) {
      this.styleObj.left = `${this.getSidebarWidth}px`;
      this.styleObj.width = `calc(100% - ${this.getSidebarWidth}px)`;
      this.styleObj.top = '50px';
    }
  }

  get getSidebarWidth() {
    return this.$store.state.getSidebar.width;
  }

  get breadcrumbData() {
    const data = this.$store.state.getBreadcrumb.breadcrumb;
    return data;
  }

  get page_num() {
    const store = this.$store.getters;
    if (
      store &&
      store.getList &&
      store.getList.paginator &&
      store.getList.paginator.page_num
    ) {
      return store.getList.paginator.page_num;
    }
    return 1;
  }

  public breadSubstring(label: any) {
    const that = this;
    const text = label.substring(0, 4);
    if (text === 'NODE') {
      return this.$t(`Permission.${label}`);
    }
    return label;
  }

  /** 關鍵字搜尋 */
  private search(search_complex: string) {
    const query: any = { search_complex, page: 1 };
    this.$router.push({ query });
  }

  /**
   * 傳送頁數 (未完)
   */
  public submitPage(feature: string) {
    let page = this.paginator;
    const num = this.page_num;
    let query: any = { ...this.$route.query, page };
    switch (feature) {
      case 'goPage':
        query = { ...this.$route.query, page };
        break;
      case 'firstPage':
        page = 1;
        query = { ...this.$route.query, page };
        break;
      case 'prevPage':
        page = page - 1 > 1 ? page - 1 : 1;
        query = { ...this.$route.query, page };
        break;
      case 'nextPage':
        page = Number(page) + 1 > num ? num : Number(page) + 1;
        query = { ...this.$route.query, page };
        break;
      case 'lastPage':
        page = this.page_num;
        query = { ...this.$route.query, page: this.page_num };
        break;
      default:
        break;
    }
    this.$router.push({ query });
  }

  /**
   * 將麵包屑用遞迴方式實做出來
   */

  private actions(data: Array<object>, urlList: Array<object>, pid?: number) {
    const that = this;
    if (pid !== null) {
      const node: any = urlList.find((item: any) => item.p4_node_id === pid);
      data.push({
        label: node.p4_node_code,
        href: node.p4_node_route,
        icon: node.icon,
      });
      that.actions(data, urlList, node.p4_node_pid);
    }
  }

  public breadcrumbList() {
    const tempData: Array<object> = [];
    const urlList = JSON.parse(localStorage.getItem('Node') || '{}');
    const routeUrl = this.$route.meta.url;
    const node = urlList.filter(
      (item: any) => item.p4_node_route === routeUrl,
    )[0];
    tempData.push({
      label: node.p4_node_code,
      href: node.p4_node_route,
      icon: node.icon,
    });
    this.actions(tempData, urlList, node.p4_node_pid);
    tempData.reverse();
    return tempData;
  }

  /**
   * getCrud 與router和本地端的crud做計算
   */
  public getCrud(feature: toolbar): boolean {
    const routerToolbars: toolbar[] = this.$route.meta.toolbar;
    const toolbarCrud: number = getToolbarCrud(feature);
    const routerPermission: boolean = getRouterPermission(
      routerToolbars,
      feature,
    ); // 儲存在開發端router上的權限
    const localePermission: boolean = (this.$crud & toolbarCrud) !== 0; // 儲存在使用者端的menu權限
    return routerPermission && localePermission; // 兩者共同計算
  }

  /**
   * created 接收bus訊號，並改變自身的dialog顯示狀態
   */
  private created() {
    this.$bus.$on('toolbar', (status: boolean) => {
      this.toolbar = status;
    });
    this.$bus.$on('PC_sidebar', (params: boolean) => {
      this.collapse = params;
    });

    this.breadcrumb = this.breadcrumbList();

    const key: any = this.$route.query.search_complex;
    this.keyword = key;
  }
}
